import type { GameId } from '@ofc/shared';

/**
 * Every screen past the landing page is its own download, fetched when it is
 * first needed: somebody joining a quiz never pays for the other nine games.
 * Kept apart from App so the landing page and the lounge can start a game's
 * download the moment it is picked, before the route even changes.
 */
export const screenLoaders = {
  movie: () => import('./screens/Room'),
  quiz: () => import('./quiz/QuizRoomScreen'),
  quiplash: () => import('./quiplash/QuiplashRoomScreen'),
  fibbage: () => import('./fibbage/FibbageRoomScreen'),
  enough: () => import('./enough/EnoughRoomScreen'),
  wavelengths: () => import('./wavelengths/WaveRoomScreen'),
  obscurity: () => import('./obscurity/ObscurityRoomScreen'),
  superlatives: () => import('./superlatives/SuperlativesRoomScreen'),
  chameleon: () => import('./chameleon/ChameleonRoomScreen'),
  hottakes: () => import('./hottakes/HotTakesRoomScreen'),
  // The solo and duel games share one screen, and so one download.
  higherlower: () => import('./arcade/ArcadeRoomScreen'),
  castreveal: () => import('./arcade/ArcadeRoomScreen'),
  posterzoom: () => import('./arcade/ArcadeRoomScreen'),
  sixdegrees: () => import('./arcade/ArcadeRoomScreen'),
  connect4: () => import('./arcade/ArcadeRoomScreen'),
  noughts: () => import('./arcade/ArcadeRoomScreen'),
  battleships: () => import('./arcade/ArcadeRoomScreen'),
  dots: () => import('./arcade/ArcadeRoomScreen'),
  wordduel: () => import('./arcade/ArcadeRoomScreen'),
  anagrams: () => import('./arcade/ArcadeRoomScreen'),
  poker: () => import('./arcade/ArcadeRoomScreen'),
  liarsdice: () => import('./arcade/ArcadeRoomScreen'),
  whosaid: () => import('./arcade/ArcadeRoomScreen'),
  wouldyourather: () => import('./arcade/ArcadeRoomScreen'),
  cheat: () => import('./arcade/ArcadeRoomScreen'),
  rankem: () => import('./arcade/ArcadeRoomScreen'),
  spotlight: () => import('./arcade/ArcadeRoomScreen'),
  blindranking: () => import('./arcade/ArcadeRoomScreen'),
  onestar: () => import('./arcade/ArcadeRoomScreen'),
  wagerquiz: () => import('./arcade/ArcadeRoomScreen'),
  fakinit: () => import('./arcade/ArcadeRoomScreen'),
  undercover: () => import('./arcade/ArcadeRoomScreen'),
  mole: () => import('./arcade/ArcadeRoomScreen'),
  boxart: () => import('./arcade/ArcadeRoomScreen'),
} satisfies Record<GameId, () => Promise<unknown>>;

/** Starts a screen's download early. Safe to call any number of times. */
export function prefetchGame(game: GameId | 'lounge' | 'daily'): void {
  // Only a head start: a failure here is retried, properly, when the screen opens.
  const quietly = (load: Promise<unknown>) => void load.catch(() => {});
  if (game === 'lounge') quietly(import('./lounge/LoungeScreen'));
  else if (game === 'daily') quietly(import('./daily/DailyScreen'));
  else quietly(screenLoaders[game]());
}
